import { useEffect, useReducer, useRef, useState } from "react"


type LegendasWrapperProps = {
    position: { x: number, y: number },
    dimensions: { width: number, height: number },
    children: any,
    setBoxSelected: (value: boolean) => void,
    setBoxSelectedAt: (value: { x: number, y: number }) => void,
    boxSelected: boolean
}

type DraggerProps = {
    dimensions: { width: number, height: number },
    setBoxSelected: (value: boolean) => void,
    boxSelected: boolean
}



export function LegendasWrapper({ position, dimensions, setBoxSelectedAt, boxSelected, setBoxSelected, children }: LegendasWrapperProps) {

    const svgRef = useRef<any>(null);

    return (
        <g transform={`translate(${position.x}, ${position.y})`}>
            <svg
            ref={svgRef}
             onMouseDown={(e : any) => {
                var pt = svgRef.current?.createSVGPoint();

                pt.x = e.clientX ;
                pt.y = e.clientY;

                const realCoords = pt.matrixTransform(svgRef.current?.getScreenCTM()?.inverse());
                setBoxSelected(true)
                setBoxSelectedAt({x: realCoords.x, y: realCoords.y});
            }}
             onMouseUp={() => setBoxSelected(false)}
            width={dimensions.width} height={dimensions.height} viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}  overflow={"visible"}
            cursor={boxSelected ? 'grabbing' : 'grab'}
            >
                <rect x={0} y={0} width={dimensions.width} height={dimensions.height} fill={'white'} stroke={'grey'} opacity={boxSelected ? 0.2 : 0.8} rx={5} />
                {/* <Dragger dimensions={dimensions} boxSelected={boxSelected} setBoxSelected={setBoxSelected} /> */}
                <g transform="translate(0, 0)">
                    {children}
                </g>
            </svg>
        </g>
    )

}